var _rect, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconLocation(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 52,
    height: 52,
    rx: 14,
    fill: "#DEF2F1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26 35C26 35 33 29 33 24C33 23.0807 32.8189 22.1705 32.4672 21.3212C32.1154 20.4719 31.5998 19.7003 30.9497 19.0503C30.2997 18.4002 29.5281 17.8846 28.6788 17.5328C27.8295 17.1811 26.9193 17 26 17C25.0807 17 24.1705 17.1811 23.3212 17.5328C22.4719 17.8846 21.7003 18.4002 21.0503 19.0503C20.4002 19.7003 19.8846 20.4719 19.5328 21.3212C19.1811 22.1705 19 23.0807 19 24C19 29 26 35 26 35Z",
    stroke: "#3AAFA9",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26 26.5C27.3807 26.5 28.5 25.3807 28.5 24C28.5 22.6193 27.3807 21.5 26 21.5C24.6193 21.5 23.5 22.6193 23.5 24C23.5 25.3807 24.6193 26.5 26 26.5Z",
    stroke: "#3AAFA9",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLocation);
export default __webpack_public_path__ + "static/media/icon-location.2516e54e0e5a37bb01419d9d9d1b0d5e.svg";
export { ForwardRef as ReactComponent };